import React from 'react';
import { NavLink } from 'react-router-dom';
import SideBarPlaceholder from "../../../components/sidebar-placeholder/sidebar-placeholder.component";

import "./aside-menu-list.styless.scss";
import PermissionGuard from '../../../auth/PermissionGuard';
import { UserRole } from '../../../auth/user-roles';

const AsideMenuList = () => {
  const [isOpen, setIsOpen] = React.useState(true);

  const toggleSubmenu = () => {
    setIsOpen(!isOpen);
  };

  return <>
    {/* begin::Menu Nav */}
    <ul className={`menu-nav`}>

      <li className="menu-item " aria-haspopup="true" style={{ padding: "9px 25px", fontWeight: "bold", backgroundColor: "rgb(243, 246, 249)" }}>

        <div
          className="menu-link d-flex justify-content-between align-items-center"
          onClick={toggleSubmenu}
          style={{ cursor: "pointer" }}
        >
          <span className="menu-title">Pages</span>
          <i className={`fas fa-chevron-${isOpen ? "up" : "down"}`}></i>
        </div>
      </li>

      {isOpen && <>
        {/*begin::1 Level*/}
        <li className="menu-item " aria-haspopup="true">
          <NavLink to="/" exact className="menu-link " activeClassName="menu-item-active">
            <i className="menu-icon flaticon-home"></i><span className="menu-text">Home</span>
          </NavLink>
        </li>
        <PermissionGuard allowedRoles={[UserRole.Admin]}>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/sessions" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon2-graphic-1"></i><span className="menu-text">VM Sessions</span>
            </NavLink>
          </li>
        </PermissionGuard>
        <PermissionGuard allowedRoles={[UserRole.Admin]}>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/screenshots" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon2-menu"></i><span className="menu-text">Screenshots</span>
            </NavLink>
          </li>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/feedbacks" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon-notes"></i><span className="menu-text">Feedbacks</span>
            </NavLink>
          </li>
        </PermissionGuard>
        <PermissionGuard allowedRoles={[UserRole.Admin, UserRole.Sales]}>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/users" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon-users"></i><span className="menu-text">Users</span>
            </NavLink>
          </li>
        </PermissionGuard>
        <PermissionGuard allowedRoles={[UserRole.Admin]}>
          {/* <li className="menu-item " aria-haspopup="true">
            <NavLink to="/dwsim-pro-licenses" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon-users-1"></i><span className="menu-text">DWSIM Pro Licenses</span>
            </NavLink>
          </li>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/dwsim-pro-analytics" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon2-analytics"></i><span className="menu-text">DWSIM Pro Analytics</span>
            </NavLink>
          </li> */}


          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/organizations" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon2-group"></i><span className="menu-text">Organizations</span>
            </NavLink>
          </li>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/tp-organizations" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon2-group"></i><span className="menu-text">TP Organizations</span>
            </NavLink>
          </li>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/webinars" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon far fa-calendar-alt"></i><span className="menu-text">Webinars</span>
            </NavLink>
          </li>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/pricing-inquiries" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon fas fa-tags"></i><span className="menu-text">Pricing inquiries</span>
            </NavLink>
          </li>
        </PermissionGuard>
        <PermissionGuard allowedRoles={[UserRole.Admin, UserRole.Sales]}>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/login-questionaire" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon fas fa-clipboard-list"></i><span className="menu-text">Login questionaire</span>
            </NavLink>
          </li>
        </PermissionGuard>
        <PermissionGuard allowedRoles={[UserRole.Admin]}>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/host-pools" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon2-box"></i><span className="menu-text">Host pools</span>
            </NavLink>
          </li>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/disaptcher-usage" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon flaticon-statistics"></i><span className="menu-text">Dispatcher usage</span>
            </NavLink>
          </li>
          <li className="menu-item " aria-haspopup="true">
            <NavLink to="/elastic-search" className="menu-link " activeClassName="menu-item-active">
              <i className="menu-icon bi bi-search"></i><span className="menu-text">Elastic search</span>
            </NavLink>
          </li>
        </PermissionGuard>


      </>}


    </ul>
    {/* end::Menu Nav */}
  </>
}
export default AsideMenuList
